module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.bf26dc0f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-italic-webfont.ttf
// module id = 508
// module chunks = 0